import { render, staticRenderFns } from "./iconHeart.vue?vue&type=template&id=03058f16"
import script from "./iconHeart.vue?vue&type=script&lang=js"
export * from "./iconHeart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports